import type { Category, CategoryMeta, Status, StatusMeta } from "@/lib/types";

export const CATEGORIES: Record<Category, CategoryMeta> = {
  messaging: { label: "Messaging & Positioning", color: "#2980B9" },
  pricing: { label: "Pricing & Packaging", color: "#8E44AD" },
  enablement: { label: "Training & Enablement", color: "#27AE60" },
  demo: { label: "Demo & Proof", color: "#E67E22" },
  design: { label: "Design & Website", color: "#E74C3C" },
  marketing: { label: "Marketing & Demand", color: "#F39C12" },
  cs: { label: "Onboarding & CX", color: "#1ABC9C" },
  systems: { label: "Internal Systems & Tracking", color: "#7F8C8D" },
  billing: { label: "Billing & Subscription", color: "#16A085" },
  deal_exec: { label: "Deal Execution", color: "#C0392B" },
  people_comp: { label: "People, Comp & Org", color: "#9B59B6" },
  pipeline_ops: { label: "Pipeline & RevOps", color: "#D35400" },
  outbound: { label: "Outbound & Felix Coverage", color: "#D81B60" },
  post_launch: { label: "Post-Launch", color: "#6C5CE7" },
};

export const STATUS_MAP: Record<Status, StatusMeta> = {
  complete: { label: "Complete", color: "text-emerald-700", bg: "bg-emerald-50", dot: "bg-emerald-500" },
  in_progress: { label: "In Progress", color: "text-sky-700", bg: "bg-sky-50", dot: "bg-sky-500" },
  not_started: { label: "Not Started", color: "text-slate-600", bg: "bg-slate-100", dot: "bg-slate-400" },
  blocked: { label: "Blocked", color: "text-rose-700", bg: "bg-rose-50", dot: "bg-rose-500" },
  at_risk: { label: "At Risk", color: "text-amber-700", bg: "bg-amber-50", dot: "bg-amber-500" },
};
